module.exports = __webpack_public_path__ + "img/pick3.dec512e2.png";